/**
 * 全站路由配置
 *
 * meta参数说明
 * keepAlive是否缓冲页面
 * isTab是否加入到tag导航
 * isAuth是否需要授权
 */
import VueRouter from "vue-router";
import PageRouter from "./page/";
import ViewsRouter from "./views/";
import AvueRouter from "./avue-router";
import Vue from "vue";
import i18n from "@/lang"; // Internationalization
import Store from "../store/";

// 注册 VueRouter 插件
Vue.use(VueRouter);

// 解决重复点击相同菜单时的 NavigationDuplicated 警告
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

let Router = new VueRouter({
  mode: "history", //后端支持可开
  base: "/admin",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if (from.meta.keepAlive) {
        from.meta.savedPosition = document.body.scrollTop;
      }
      return {
        x: 0,
        y: to.meta.savedPosition || 0,
      };
    }
  },
  routes: [],
});
AvueRouter.install(Vue, Router, Store, i18n);
Router.$avueRouter.formatRoutes(Store.state.user.menu, true);
// 使用 addRoute 替代已废弃的 addRoutes
[...PageRouter, ...ViewsRouter].forEach((route) => {
  Router.addRoute(route);
});
export default Router;
